export const PRIVACY_POLICY_LAST_UPDATED = "7 januari 2025";

export interface PolicySubsection {
  title: string;
  body: string;
}

export interface PolicySection {
  title: string;
  subsections: PolicySubsection[];
}

export const PRIVACY_POLICY_SECTIONS: PolicySection[] = [
  {
    title: "Användarvillkor",
    subsections: [
      {
        title: "1. Acceptans av villkor",
        body: "Genom att använda Varna-appen accepterar du dessa villkor. Om du inte accepterar villkoren, vänligen avsluta användningen av appen.",
      },
      {
        title: "2. Användning av tjänsten",
        body: "Varna är en säkerhetsapp avsedd för företag och organisationer. Du förbinder dig att använda appen i enlighet med dess syfte och gällande lagar.",
      },
      {
        title: "3. Användarkonto",
        body: "Du är ansvarig för att hålla dina inloggningsuppgifter konfidentiella och för all aktivitet som sker under ditt konto.",
      },
      {
        title: "4. Ansvarsbegränsning",
        body: 'Varna tillhandahålls "som den är". Vi garanterar inte att tjänsten alltid kommer att vara tillgänglig eller felfri. Vi ansvarar inte för eventuella skador som uppstår till följd av användningen av appen.',
      },
    ],
  },
  {
    title: "Integritetspolicy",
    subsections: [
      {
        title: "1. Insamling av data",
        body: "Vi samlar in följande information:\n• Personuppgifter (namn, e-post)\n• Platsdata för säkerhetsfunktioner\n• Användningsdata och enhetsinformation\n• Meddelanden och kommunikation",
      },
      {
        title: "2. Användning av data",
        body: "Din data används för att:\n• Tillhandahålla säkerhetstjänster\n• Hantera larm och incidenter\n• Förbättra appens funktionalitet\n• Kommunicera med dig om tjänsten",
      },
      {
        title: "3. Delning av data",
        body: "Vi delar din data endast:\n• Med din arbetsgivare/organisation\n• Med säkerhetspersonal vid larm\n• När lagen kräver det\n• Med ditt uttryckliga samtycke",
      },
      {
        title: "4. Platsdata",
        body: "Vi använder din platsdata för att:\n• Skicka din position vid larm\n• Aktivera geofencing-funktioner\n• Spåra ensambete\nPlatsdata delas endast när det är nödvändigt för säkerhetsfunktioner.",
      },
      {
        title: "5. Dataskydd",
        body: "Vi använder branschstandarder för att skydda din data, inklusive kryptering och säkra servrar. All data lagras i enlighet med GDPR.",
      },
      {
        title: "6. Dina rättigheter",
        body: "Du har rätt till:\n• Få tillgång till din data\n• Rätta felaktig information\n• Radera din data\n• Invända mot databehandling\n• Få dataportabilitet",
      },
      {
        title: "7. Cookies och spårning",
        body: "Vi använder cookies och liknande tekniker för att förbättra appens funktionalitet och användarupplevelse.",
      },
      {
        title: "8. Ändringar i policyn",
        body: "Vi kan uppdatera denna policy. Väsentliga ändringar kommer att meddelas via appen eller e-post.",
      },
    ],
  },
  {
    title: "Kontakt",
    subsections: [
      {
        title: "",
        body: "För frågor om dessa villkor eller vår integritetspolicy, kontakta:\n\nAffärsmässiga frågor: sizar@satelles.se\nTeknisk support: support@varna.se",
      },
    ],
  },
];
